<template>
  <div id="appBarLayout">
    <main>
      <right-slider-menu
        :is-menu-open="isRightSliderMenuOpen"
        @close="closeRightSliderMenu"
      />
      <right-slide-modal
        :is-show="isRightSliderModalOpen"
        @show="handleShowRightSliderModal"
        @close="isRightSliderModalOpen = false"
      />
      <org-management-header
        @menu-dots-click="handleRightMenuOpen"
        @notification-click="handleNotificationOpen"
      />
      <div id="body">
        <div
          class="left-sidebar"
          :class="`${overlayLanding ? '!tw-z-[4]' : ''} tw-relative tw-flex ${
            isMenuOpen ? '' : 'tw-z-[2]'
          } ${zIndexMenu === 0 ? '!tw-z-[1]' : ''}`"
        >
          <!-- @clicked-active="handleClickedActive" -->
          <primary-menu
            :icons="primaryMenuIcons"
            :is-menu-open="isMenuOpen"
            :hover-menu-index="hoverMenuIndex"
            @on-selected-icon-index-change="onPrimaryMenuChange"
            @hovered-icon="openMenu"
            @unhovered-icon="setIsMenuOpen(false)"
            @set-hovered-index="setHoverMenuIndex"
            @set-is-menu-open="setIsMenuOpen"
            @toggle-menu="toggleMenu"
          />
          <span
            :class="`toggleIconWrapper tw-bottom-[19px] tw-left-[2px] md:tw-left-[unset]  md:tw-top-[24px] ${
              isMenuOpen ? 'md:tw-right-[-8px]' : 'md:tw-right-[-8px]'
            } ${zIndexMenu === 0 ? '!tw-z-[3]' : ''} ${
              isOverlayMainVisible && !isChevronActive && isMenuOpen
                ? '!tw-right-[-229px]'
                : ''
            }`"
            @click="handleClickedActive"
          >
            <Chevrons :class="`toggle-icon ${isMenuOpen ? '' : 'active'}`" />
          </span>
          <div
            :class="`collapsible-wrapper ${
              isOverlayMainVisible && !isChevronActive
                ? '!tw-absolute tw-h-[100%] tw-left-[62px]'
                : ''
            } ${zIndexMenu === 0 ? '!tw-z-[0]' : ''}`"
          >
            <collapsable-menu
              :section-title="primaryMenuIcons[hoverMenuIndex]?.sectionTitle"
              :section-sub-title="
                primaryMenuIcons[hoverMenuIndex]?.sectionSubTitle
              "
              :menu-url="primaryMenuIcons[hoverMenuIndex]?.url"
              :menu-items="menuItems[hoverMenuIndex]"
              :is-menu-open="isMenuOpen"
              @set-active-hierarchy="setActiveHierarchy"
              @set-is-menu-open="setIsMenuOpen(!isMenuOpen)"
            />
          </div>
        </div>
        <div
          id="slot-wrapper"
          :class="`main-body ${
            (overlayLanding || $route.path === ROUTERS.shareProfile) &&
            isChevronActive
              ? '!tw-overflow-visible'
              : ''
          }`"
        >
          <div
            :class="`${
              isChevronActive && isMenuOpen ? 'slot-main' : 'slot-main-full-w'
            } `"
          >
            <!-- The <slot> element is a slot outlet that indicates where the "VIEW" content should be rendered. -->
            <slot
              :active-hierarchy="activeHierarchy"
              :is-menu-open="isMenuOpen"
            />
          </div>
        </div>
        <Notification
          :is-notification-nav="isNotificationficationOpen"
          @close-notification="closeNotification"
        />
        <div
          v-show="isOverlayVisible"
          class="overlay color"
          @click="closeRightSliderMenu"
        />
        <div
          v-if="
            isMenuOpen &&
            !(isChevronActive && hoverMenuIndex === primaryMenuIndex)
          "
          :class="`overlay ${overlayLanding ? '!tw-z-[4]' : ''} ${
            isMenuOpen && !isMobileView ? '!tw-left-[280px]' : ''
          }`"
          @mouseover="hoverOnOverlay"
        />
        <errorhandler
          v-if="isErrorPopupOpen() || null"
          :prospect-callback-error-msg="getErrorMessage()"
          @reset-show-prospect-callback-error="onCloseErrorPopup"
        />
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import OrgManagementHeader from "@/components/common/orgManagementHeader.vue";
import PrimaryMenu from "@/components/common/primaryMenu.vue";
import { Component, Vue, Watch } from "vue-facing-decorator";
import { PrimaryMenuIcon } from "@/components/common/primaryMenu.vue";
import CollapsableMenu from "@/components/common/collapsableMenu.vue";
import { Ref, ref } from "vue";
import { CollapsableMenuItemType } from "@/components/common/collapsibleMenuItem.vue";
import Utils, { checkParentIndex, getComponentUiText } from "@/utils/utilities";
import RightSliderMenu from "@/components/common/rightSliderMenu.vue";
import EyeSearchIcon from "@/components/svgs/eyeSearchIcon.vue";
import store from "@/store";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import Chevrons from "@/components/svgs/chevrons.vue";
import notification from "@/components/notification/notification.vue";
import errorhandler from "@/components/common/exceptionHandler.vue";
import { env } from "@/env";
import RightSlideModal from "../common/rightSlideModal.vue";
import FourDotsIcon from "../svgs/fourDotsIcon.vue";
import AssessmentInputIcon from "../svgs/assessmentInputIcon.vue";
import RecommendationIcon from "../svgs/recommendationIcon.vue";
import ChecklistBarIcon from "../svgs/checklistBarIcon.vue";
import CypherReportIcon from "../svgs/cypherReportIcon.vue";
import QuestionMarkIcon from "../svgs/questionMarkIcon.vue";
import SettingIcon from "../svgs/settingIcon.vue";
import { routers } from "@/utils/constants";
import router from "@/router";
import { homeRoute } from "@/services/apiRoutes/routes";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import DashboardLogo from "../svgs/dashboardLogo.vue";
import assessmentCreateLogo from "../svgs/assessmentCreateLogo.vue";
import assessmentInputLogo from "../svgs/assessmentInputLogo.vue";
import recommendationLogo from "../svgs/recommendationLogo.vue";
import cyberHealthLogo from "../svgs/cyberHealthLogo.vue";
import scanScanningLogo from "../svgs/scanningLogo.vue";
import eventEmitter from "@/utils/eventEmitter";
import AssessmentVendorLogo from "../svgs/assessmentVendorLogo.vue";
import AssessmentVendorIcon from "../svgs/assessmentVendorIcon.vue";

@Component({
  components: {
    OrgManagementHeader: OrgManagementHeader,
    PrimaryMenu: PrimaryMenu,
    CollapsableMenu: CollapsableMenu,
    RightSliderMenu: RightSliderMenu,
    backgroundComponent,
    Chevrons,
    Notification: notification,
    errorhandler,
    RightSlideModal,
  },
})
export default class AppBarLayout extends Vue {
  public primaryMenuIndex: number | any = ref(
    store.state.Navigation.primaryMenuIndex || 0,
  );
  public isRightSliderMenuOpen: boolean | Ref = ref(false);
  public isRightSliderModalOpen: boolean | Ref = ref(false);
  public isNotificationficationOpen: boolean | Ref = ref(false);
  public activeHierarchy: any[] | Ref = ref([]);
  public isOverlayVisible: boolean | Ref = ref(false);
  public isShowOverlayRightSliderModal: boolean | Ref = ref(true);
  public showTooltipMessage: string | Ref = ref("");
  public isHover: boolean | Ref = ref(false);
  public hoverMenuIndex: number | any = ref(
    store.state.Navigation.primaryMenuIndex || 0,
  );
  public isOverlayMainVisible: boolean | Ref = ref(false);
  public isMobileView: boolean | Ref = ref(false);

  private timeOutRef: any | number | null = null;
  private timeOutHoverRef: any | number | null = null;
  private zIndexMenu: any | number | null = 2;
  private ROUTERS = routers;

  get primaryMenuIcons(): PrimaryMenuIcon[] {
    const learnUrl = process.env.VUE_APP_PRODUCT_FRUIT_KB_URL || "";

    const output: PrimaryMenuIcon[] = [
      {
        icon: FourDotsIcon,
        id: "menu-icon-home",
        alt: "4-dots_icon",
        sectionSubTitle: this.getUiText("app-menu-submenu-home-dashboard-1"),
        sectionTitle: this.getUiText("app-menu-home-1"),
        url: homeRoute.homePage,
      },
      {
        icon: ChecklistBarIcon,
        id: "menu-icon-manage-assessments",
        alt: "checklist_icon",
        sectionTitle: this.getUiText(
          "app-menu-submenu-assess-manage-assessments-1",
        ),
        url: routers.assessCreate,
      },
      {
        id: "menu-icon-complete-assessments",
        icon: AssessmentInputIcon,
        alt: "assessment_icon",
        sectionTitle: this.getUiText(
          "app-menu-submenu-assess-complete-assessments-1",
        ),
        url: routers.assessChecklist,
      },
      {
        id: "menu-icon-recommendations",
        icon: RecommendationIcon,
        alt: "recommen_icon",
        sectionTitle: this.getUiText(
          "app-menu-submenu-assess-recommendations-1",
        ),
        url: routers.assessRecommend,
      },
      // {
      //   icon: RiskIcon,
      //   alt: "risk_icon",
      //   sectionTitle: this.getUiText("app-menu-risk-1"),
      // },
      // {
      //   icon: ComplianceIcon,
      //   alt: "compliance_icon",
      //   sectionTitle: this.getUiText("app-menu-compliance-1"),
      // },
      // {
      //   icon: PentestIcon,
      //   alt: "pentest_icon",
      //   sectionTitle: this.getUiText("app-menu-pentest-1"),
      // },
      // {
      //   icon: InsuranceIcon,
      //   alt: "insurance_icon",
      //   sectionTitle: this.getUiText("app-menu-insurance-1"),
      // },
      // {
      //   icon: ShareIcon,
      //   alt: "share_lhs_icon",
      //   sectionTitle: this.getUiText("app-menu-share-1"),
      // },
      {
        id: "menu-icon-cyber-health-report",
        icon: CypherReportIcon,
        alt: "share_lhs_icon",
        sectionTitle: this.getUiText(
          "app-menu-submenu-share-cyber-health-report-1",
        ),
        url: routers.shareProfile,
      },
      {
        id: "menu-icon-assessment-vendor",
        icon: AssessmentVendorIcon,
        alt: "assessment_vendor_icon",
        sectionTitle: this.getUiText(
          "app-menu-submenu-assess-vendor-assessments-1",
        ),
        url: routers.assessVendor,
      },
      {
        id: "menu-icon-scanning",
        icon: EyeSearchIcon,
        alt: "eye-search_icon",
        sectionTitle: this.getUiText("app-menu-submenu-scan-scanning-1"),
        url: routers.scanScanning,
      },
      // {
      //   icon: ServiceIcon,
      //   alt: "service_provider_icon",
      //   sectionTitle: this.getUiText("app-menu-service-1"),
      // },
      {
        id: "menu-icon-settings",
        icon: SettingIcon,
        alt: "setting_icon",
        sectionTitle: this.getUiText("app-menu-submenu-settings-1"),
      },
    ];
    if (learnUrl && learnUrl.includes("/")) {
      output.push({
        id: "menu-icon-learn",
        icon: QuestionMarkIcon,
        alt: "questionmark_icon",
        sectionTitle: this.getUiText("app-menu-learn-1"),
        url: learnUrl,
        onSelect: () => {
          window.open(learnUrl, "_blank")?.focus();
        },
      });
    }
    return output;
  }

  get overlayLanding(): boolean {
    return store.state.Overlay.isOverlayLandingPage;
  }

  get menuItems(): CollapsableMenuItemType[][] {
    if (this.menuItems) {
      return this.menuItems;
    }
    return [
      [
        {
          title: getComponentUiText("app-menu-home-1"),
          url: routers.dashboard,
          description: getComponentUiText(
            "app-menu-submenu-dashboard-page-description-1",
          ),
          instruction: getComponentUiText(
            "app-menu-submenu-dashboard-page-instruction-1",
          ),
          instructionTitle: getComponentUiText(
            "app-menu-submenu-instruction-1",
          ),
          logo: DashboardLogo,
        },
      ],
      [
        {
          title: getComponentUiText(
            "app-menu-submenu-assess-manage-assessments-1",
          ),
          url: routers.assessCreate,
          description: getComponentUiText(
            "app-menu-submenu-assessments-create-page-description-1",
          ),
          instruction: getComponentUiText(
            "app-menu-submenu-assessments-create-page-instruction-1",
          ),
          instructionTitle: getComponentUiText(
            "app-menu-submenu-instruction-1",
          ),
          logo: assessmentCreateLogo,
        },
        // {
        //   title: "app-menu-submenu-assess-benchmarking-1",
        //   url: routers.assessBenchmark,
        // },
      ],
      [
        {
          title: getComponentUiText(
            "app-menu-submenu-assess-manage-assessments-1",
          ),
          url: routers.assessChecklist,
          description: getComponentUiText(
            "app-menu-submenu-assessments-input-page-description-1",
          ),
          instruction: getComponentUiText(
            "app-menu-submenu-assessments-input-page-instruction-1",
          ),
          instructionTitle: getComponentUiText(
            "app-menu-submenu-instruction-1",
          ),
          logo: assessmentInputLogo,
        },
      ],
      [
        {
          title: getComponentUiText(
            "app-menu-submenu-assess-recommendations-1",
          ),
          url: routers.assessRecommend,
          description: getComponentUiText(
            "app-menu-submenu-recommendation-page-description-1",
          ),
          instruction: getComponentUiText(
            "app-menu-submenu-recommendation-page-instruction-1",
          ),
          instructionTitle: getComponentUiText(
            "app-menu-submenu-instruction-1",
          ),
          logo: recommendationLogo,
        },
      ],
      // [
      //   {
      //     title: "app-menu-submenu-risk-dashboard-1",
      //     url: routers.riskDashboard,
      //   },
      // ],
      // [
      //   {
      //     title: "app-menu-submenu-compliance-audits-1",
      //     url: routers.complianceAudits,
      //   },
      // ],
      // [
      //   {
      //     title: "app-menu-submenu-pentest-pentests-1",
      //     url: routers.pentestPentests,
      //   },
      // ],
      // [
      //   {
      //     title: "app-menu-submenu-insurance-questionnaires-1",
      //     url: routers.insuranceQuestionnaires,
      //   },
      // ],
      [
        {
          title: getComponentUiText("app-menu-submenu-share-cyber-profile-1"),
          url: routers.shareProfile,
          description: getComponentUiText(
            "app-menu-submenu-cyber-report-page-description-1",
          ),
          instruction: getComponentUiText(
            "app-menu-submenu-cyber-report-page-instruction-1",
          ),
          instructionTitle: getComponentUiText(
            "app-menu-submenu-instruction-1",
          ),
          logo: cyberHealthLogo,
        },
        // {
        //   title: "app-menu-submenu-share-external-assessments-1",
        //   url: routers.shareExternal,
        // },
      ],
      [
        {
          title: getComponentUiText(
            "app-menu-submenu-assess-vendor-assessments-1",
          ),
          url: routers.assessVendor,
          description: getComponentUiText(
            "app-menu-submenu-assessments-vendor-page-description-1",
          ),
          instruction: getComponentUiText(
            "app-menu-submenu-assessments-vendor-page-instruction-1",
          ),
          instructionTitle: getComponentUiText(
            "app-menu-submenu-instruction-1",
          ),
          logo: AssessmentVendorLogo,
        },
      ],
      [
        {
          title: getComponentUiText("app-menu-submenu-scan-scanning-1"),
          url: routers.scanScanning,
          description: getComponentUiText(
            "app-menu-submenu-scanning-page-description-1",
          ),
          instruction: getComponentUiText(
            "app-menu-submenu-scanning-page-instruction-1",
          ),
          instructionTitle: getComponentUiText(
            "app-menu-submenu-instruction-1",
          ),
          logo: scanScanningLogo,
        },
        // {
        //   title: "app-menu-submenu-scan-technology-and-assets-1",
        //   url: routers.scanTechassets,
        // },
      ],
      // [
      //   {
      //     title: "app-menu-submenu-service-provider-market-place-1",
      //     url: routers.serviceMarket,
      //   },
      // ],
      [
        {
          title: getComponentUiText("app-menu-submenu-settings-setup-1"),
          url: routers.settingsSetup,
          dataCy: "org-setup",
        },
        {
          title: getComponentUiText("app-menu-submenu-settings-org-1"),
          dataCy: "org-settings",
          children: [
            {
              icon: "/img/fingerprint_icon.svg",
              title: getComponentUiText(
                "app-menu-submenu-settings-org-details-1",
              ),
              url: routers.settingOrgDetails,
              dataCy: "org-details",
            },
            {
              icon: "/img/fingerprint_icon.svg",
              title: getComponentUiText(
                "app-menu-submenu-settings-org-profile-1",
              ),
              url: routers.settingOrgProfile,
              dataCy: "org-profile",
            },
            {
              icon: "/img/fingerprint_icon.svg",
              title: getComponentUiText(
                "app-menu-submenu-settings-org-manage-access-1",
              ),
              url: routers.settingOrgManageAccess,
              dataCy: "org-manage-access",
            },
          ],
        },
        {
          title: getComponentUiText("app-menu-submenu-settings-domains-1"),
          url: routers.settingDomains,
          dataCy: "org-domains",
        },
        {
          title: getComponentUiText("app-menu-submenu-settings-team-1"),
          dataCy: "org-team",
          children: [
            {
              icon: "/img/fingerprint_icon.svg",
              title: getComponentUiText(
                "app-menu-submenu-settings-team-members-1",
              ),
              url: routers.settingTeamMembers,
              dataCy: "org-team-members",
            },
            {
              icon: "/img/fingerprint_icon.svg",
              title: getComponentUiText(
                "app-menu-submenu-settings-team-roles-1",
              ),
              url: routers.settingTeamRoles,
              dataCy: "org-team-roles",
            },
          ],
        },
        {
          title: getComponentUiText("app-menu-submenu-settings-subscription-1"),
          dataCy: "org-subscription",
        },
      ],
      [
        {
          title: getComponentUiText("app-menu-submenu-learn-help-1"),
          url: routers.learnHelp,
          dataCy: "org-learn-help",
        },
      ],
    ];
  }

  get isMenuOpen() {
    return store.state.Navigation.isMenuOpen;
  }
  get isChevronActive() {
    return store.state.Navigation.chevronActive;
  }
  get checklistReportData() {
    return store.state.Sharing.checklistReportData;
  }
  get isLoadNotificationAfterLogin() {
    return store.state.Notification.isLoadAfterLogin;
  }

  isErrorPopupOpen() {
    return store.state.ErrorTooltip.visible;
  }

  getErrorMessage() {
    const message = store.state.ErrorTooltip.message;
    if (message === "") {
      return "Error";
    }
    return store.state.ErrorTooltip.message
      ? store.state.ErrorTooltip.message
      : this.getUiText("app-exception-handler-error-unknown-error");
  }

  onCloseErrorPopup() {
    store.dispatch("ErrorTooltip/hideToolTip");
  }

  @Watch("isRightSliderMenuOpen")
  handleIsRightSliderMenuOpenChange() {
    if (this.isRightSliderMenuOpen) {
      this.isOverlayVisible = true;
    } else {
      setTimeout(() => {
        this.isOverlayVisible = false;
      }, 300);
    }
  }

  @Watch("isNotificationficationOpen")
  handleisNotificationficationOpenChange() {
    if (this.isNotificationficationOpen) {
      this.isOverlayVisible = true;
    } else {
      setTimeout(() => {
        this.isOverlayVisible = false;
      }, 100);
    }
  }

  @Watch("isRightSliderModalOpen")
  handleIsRightSlideModalOpenChange() {
    if (this.isRightSliderModalOpen) {
      this.isShowOverlayRightSliderModal && (this.isOverlayVisible = true);
    } else {
      setTimeout(() => {
        this.isOverlayVisible = false;
      }, 100);
    }
  }

  @Watch("primaryMenuIndex")
  handlePrimaryMenuIndexChange() {
    store.dispatch("Navigation/setPrimaryMenuIndex", this.primaryMenuIndex);
  }

  @Watch("checklistReportData")
  getTitlePage() {
    if (
      this.activeHierarchy[0] ==
      getComponentUiText("app-menu-submenu-share-cyber-health-report-1")
    ) {
      this.activeHierarchy = [
        getComponentUiText("app-share-cyber-profile-title-1"),
        this.checklistReportData?.checklistSummary &&
        this.checklistReportData?.checklistSummary?.checklistDate
          ? `${this.checklistReportData?.checklistSummary
              ?.checklistName} - ${convertUTCTimeToLocalTime(
              this.checklistReportData?.checklistSummary?.checklistDate,
            )}`
          : "",
      ];
      store.dispatch("Navigation/setActiveHierarchy", this.activeHierarchy);
    }
  }

  @Watch("activeHierarchy")
  handleActiveHierarchyChange() {
    this.isHover = false;
    if (
      this.activeHierarchy[1] ==
      getComponentUiText("app-menu-submenu-share-cyber-profile-1")
    ) {
      this.activeHierarchy = [
        getComponentUiText("app-share-cyber-profile-title-1"),
        this.checklistReportData?.checklistSummary &&
        this.checklistReportData?.checklistSummary?.checklistDate
          ? `${this.checklistReportData?.checklistSummary
              ?.checklistName} - ${convertUTCTimeToLocalTime(
              this.checklistReportData?.checklistSummary?.checklistDate,
            )}`
          : "",
      ];
    }
    store.dispatch("Navigation/setActiveHierarchy", this.activeHierarchy);
  }

  handleShowRightSliderModal(showOverlay) {
    this.isShowOverlayRightSliderModal = showOverlay;
    this.isRightSliderModalOpen = true;
  }

  openMenu($event) {
    if (this.isBlankMenu($event) || this.isBlankMenu()) return;
    this.isHover = true;
    this.setIsMenuOpen(true);
  }

  setHoverMenuIndex(index: number) {
    if (this.timeOutHoverRef) clearTimeout(this.timeOutHoverRef);
    if (index === null) return;
    if (index !== -1) {
      this.timeOutHoverRef = setTimeout(() => {
        this.hoverMenuIndex = index;
      }, env.primaryMenuHoverDelayMS);
    } else {
      this.timeOutHoverRef = setTimeout(() => {
        this.hoverMenuIndex = this.primaryMenuIndex;
      }, 1000);
    }
  }

  // emit hover after X seconds
  hoverOnOverlay() {
    if (!this.isChevronActive) {
      this.isHover = false;
      this.clearTimeOut();
      this.timeOutRef = setTimeout(() => {
        this.hoverMenuIndex = this.primaryMenuIndex;
        this.setIsMenuOpen(false);
      }, env.primaryMenuHoverDelayMS);
      return;
    }

    if (this.hoverMenuIndex !== this.primaryMenuIndex) {
      this.clearTimeOut();
      this.timeOutRef = setTimeout(() => {
        this.hoverMenuIndex = this.primaryMenuIndex;
      }, env.primaryMenuHoverDelayMS);
    }
  }

  // clear timeout when mouse leaves
  clearTimeOut() {
    if (this.timeOutRef) {
      clearTimeout(this.timeOutRef);
      this.timeOutRef = null;
    }
  }

  onPrimaryMenuChange(index: number) {
    this.hoverMenuIndex = index;
    this.primaryMenuIndex = index;
  }

  async toggleMenu(index: number, isNavigate = true) {
    if (
      this.isMobileView &&
      index === this.primaryMenuIndex &&
      this.isMenuOpen
    ) {
      this.setIsMenuOpen(false);
      return;
    }
    if (this.isBlankMenu(index)) {
      this.setIsMenuOpen(false);
    } else this.setIsMenuOpen(true);
    setTimeout(() => {
      this.isHover = false;
    }, 1000);
    if (0 <= index && index < 7) {
      this.activeHierarchy = [
        this.primaryMenuIcons[this.primaryMenuIndex]?.sectionTitle,
      ];
      store.dispatch("Navigation/setActiveHierarchyIndex", {
        level: 0,
        index: index,
      });
      store.dispatch("Navigation/setActiveHierarchy", this.activeHierarchy);
      this.primaryMenuIndex = index;
      if (!isNavigate) return;
      if (this.primaryMenuIcons[index].url === routers.assessChecklist) {
        const lastesChecklist = await store.dispatch(
          "Recommend/fetchChecklistData",
        );
        if (
          lastesChecklist?.latestChecklist &&
          lastesChecklist?.latestChecklist.checklistId
        ) {
          router.push(
            `${routers.assessChecklist}?checklistId=${lastesChecklist?.latestChecklist.checklistId}`,
          );
        } else {
          router.push(routers.assessCreate);
        }
      } else {
        router.push(this.primaryMenuIcons[index].url || routers.dashboard);
      }
    }
  }

  setIdsToMenuItems(
    menuItems: CollapsableMenuItemType[],
    parentId?: string,
    parentTitle?: string,
  ) {
    const result = menuItems.map((item) => {
      item.id = Utils.getUniqueID();
      if (parentId) item.parentId = parentId;
      if (parentTitle) item.parentTitle = parentTitle;
      if (item.children && item.children.length > 0) {
        item.children = this.setIdsToMenuItems(
          item.children,
          `${item.parentId ? `${item.parentId}-` : ""}${item.id}`,
          `${item.parentTitle ? `${item.parentTitle}-` : ""}${item.title}`,
        );
      }
      return item;
    });
    return result;
  }

  setActiveHierarchy(activeList) {
    this.activeHierarchy = [
      this.primaryMenuIcons[this.primaryMenuIndex]?.sectionTitle,
      ...Object.values(activeList).map((item: any) => item.title),
    ];
  }

  handleRightMenuOpen() {
    if (this.isSubscriptionVisible()) return;
    this.isRightSliderMenuOpen = !this.isRightSliderMenuOpen;
  }

  isSubscriptionVisible() {
    const cond = document.getElementById("pricing-table-container");
    return cond;
  }

  handleNotificationOpen() {
    if (this.isSubscriptionVisible()) return;
    setTimeout(() => {
      const autoFocus = document.getElementsByClassName(
        "autoFocusNotify",
      )[0] as HTMLInputElement;
      autoFocus.focus();
    }, 100);
    this.isNotificationficationOpen = !this.isNotificationficationOpen;
  }

  closeRightSliderMenu() {
    this.isRightSliderMenuOpen = false;
    this.isNotificationficationOpen = false;
    this.isRightSliderModalOpen = false;
  }

  closeNotification() {
    this.isNotificationficationOpen = false;
  }

  mounted() {
    this.listeningEmitEvent();
    const menuItems: CollapsableMenuItemType[][] = [];
    for (let item of this.menuItems) {
      menuItems.push(this.setIdsToMenuItems(item));
    }
    const currentRoute = this.$route.path;
    let parentIndex, childrentIndex;
    const currentRouteIndex = this.menuItems.forEach((items, index) => {
      items.forEach((item, itemIndex) => {
        if (item.url === currentRoute) {
          parentIndex = index;
        } else if (item.children) {
          item.children.forEach((child, childIndex) => {
            if (child.url === currentRoute) {
              childrentIndex = itemIndex;
            }
          });
        }
      });
    });

    this.primaryMenuIndex = store.state.Navigation.primaryMenuIndex;
    this.activeHierarchy = store.state.Navigation.activeHierarchy;
    const activeHierarchyIndex = store.state.Navigation.activeHierarchyIndex;
    const activeTabIndex = store.state.Navigation.activeHierarchyIndex[0];
    if (activeTabIndex !== -1 && activeHierarchyIndex) {
      this.activeHierarchy = [
        this.primaryMenuIcons[activeTabIndex]?.sectionTitle,
        menuItems[activeTabIndex][activeHierarchyIndex[1]]?.title,
        menuItems[activeTabIndex][activeHierarchyIndex[1]]?.children?.[
          activeHierarchyIndex[2]
        ]?.title,
        menuItems[activeTabIndex][activeHierarchyIndex[1]]?.children?.[
          activeHierarchyIndex[2]
        ]?.children?.[activeHierarchyIndex[3]]?.title,
      ];
    }
    if (parentIndex && parentIndex !== this.primaryMenuIndex) {
      this.toggleMenu(parentIndex, false);
      setTimeout(() => {
        this.onPrimaryMenuChange(parentIndex);
      }, 100);
    }

    const isChevronActive = store.state.Navigation.chevronActive;
    if (
      !isChevronActive &&
      this.primaryMenuIndex >= 0 &&
      this.primaryMenuIndex < 7
    ) {
      this.isOverlayMainVisible = true;
    }

    this.$el.addEventListener("click", (e) => {
      if (e.target.classList[0] === "overlay" && screen.width < 768) {
        this.setIsMenuOpen(false);
      }
    });

    this.checkDevice();
    window.addEventListener("resize", this.checkDevice);

    if (!this.isLoadNotificationAfterLogin) {
      store.dispatch("Notification/getNotification", { includeActioned: true });
    } else {
      store.dispatch("Notification/setLoadAfterLogin", false);
    }
  }

  beforeDestroy() {
    this.$el.removeEventListener("click");
    this.removeEmitEventListener();
    window.removeEventListener("resize", this.checkDevice);
  }

  checkDevice() {
    this.isMobileView = window.screen.width <= 768;
  }

  listeningEmitEvent() {
    EventEmitter.on("setZIndexIConNavBar", this.showModal);
    EventEmitter.on(EmitterEvents.APP_LAYOUT_SHOW_COLLAPSABLE_MENU, (value) => {
      if (value) this.zIndexMenu = 0;
      else this.zIndexMenu = 1;
    });
  }

  showModal(data) {
    if (data) {
      const elements = document.getElementsByClassName("toggleIconWrapper");
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLElement;
        if (element.style) {
          // element.style.zIndex = "1";
        }
      }
    } else {
      const elements = document.getElementsByClassName("toggleIconWrapper");
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLElement;
        if (element.style) {
          // element.style.zIndex = "3";
        }
      }
    }
  }
  removeEmitEventListener() {
    // EventEmitter.off(EmitterEvents.OPEN_MODAL);
  }
  handleClickedActive() {
    if (this.isBlankMenu()) this.setIsMenuOpen(false);
    else {
      if (!this.isMenuOpen || this.isChevronActive) {
        store.dispatch("Navigation/setChevronActive", !this.isChevronActive);
      }
      this.setIsMenuOpen(!this.isMenuOpen, true);
    }
    EventEmitter.emit(EmitterEvents.UPDATE_CHEVRON_ACTIVE);
  }

  setIsMenuOpen(bool: boolean, isForceUpdate = false) {
    if (bool && !isForceUpdate && !this.isChevronActive) {
      this.isOverlayMainVisible = true;
    }
    if (!bool && !isForceUpdate) {
      setTimeout(() => {
        this.isOverlayMainVisible = false;
      }, 500);
    }
    if (isForceUpdate || !this.isChevronActive || bool || screen.width < 768) {
      if (bool) store.dispatch("Navigation/setMenuOpen");
      else {
        store.dispatch("Navigation/setMenuClose");
        setTimeout(() => {
          const parentIndex = checkParentIndex(
            this.$route.path,
            this.menuItems,
            this.primaryMenuIndex,
          );
          this.hoverMenuIndex = parentIndex;
          eventEmitter.emit(EmitterEvents.SET_PRIMARY_MENU_INDEX, parentIndex);
        }, 100);
      }
    }
  }

  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }

  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  isBlankMenu(index: number | undefined = undefined) {
    const primaryItems =
      typeof index === "number"
        ? this.menuItems[index] || []
        : this.menuItems[this.primaryMenuIndex] || [];

    return primaryItems.length === 0 ? true : false;
  }
}
</script>

<style lang="scss" scoped>
#appBarLayout {
  height: 100%;
  overflow-x: hidden;
}

main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#body {
  display: flex;
  flex-grow: 1;
  overflow: auto;
}

slot {
  flex: 1;
  height: 100%;
}

#slot-wrapper {
  flex: 1;
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.primary-menu-index {
  z-index: none;
}

.collapsible-wrapper {
  flex: 1;
  position: relative;
  z-index: 2;
}

.slot-main {
  /* width: calc(100% - 220px); */
  width: 100%;
  height: 100%;
  position: relative;
}
.slot-main-full-w {
  width: 100%;
  height: 100%;
  position: relative;
}
.overlay {
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
}

.overlay.color {
  background: rgb(0, 0, 0, 0.5);
  z-index: 3;
}

.toggleIconWrapper {
  width: 18px;
  height: 18px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  fill: var(--UI-white, #fff);
  z-index: 3;
  filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.1));
  transition: right 0.15s ease-in-out;
}

.toggleIconWrapper .toggle-icon {
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  position: absolute;
  width: 9.5px;
  height: 9.5px;
  top: 4px;
  left: 4.25px;
}

.toggleIconWrapper .toggle-icon.active {
  transform: rotateY(180deg);
}

@media (max-width: 767px) {
  #body {
    flex-direction: column;
    overflow: unset;
    height: calc(100% - 75.09px);
  }

  .toggleIconWrapper {
    display: none;
  }
  .collapsible-wrapper {
    position: absolute;
    top: 55px;
    left: 0;
    height: calc(100vh - 111px);
    .menu {
      width: 221px;
    }
  }
}
</style>
